import { useParams } from 'react-router-dom';

import React, { useEffect } from 'react';
import useDocumentRedirect from '../hooks/useDocumentRedirect';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import AppError404 from '../../../app/features/error/404/AppError404';
import AppLoaderContent from '../../../app/features/loader/content/AppLoaderContent';
import useCompanies from '../../user/hooks/useUserCompanys';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import DocumentRoutes from '../DocumentRoutes';
import AdminRoutes from '../../admin/AdminRoutes';

const PDocumentRedirect = () => {
	const routeParams = useParams();
	const edmId = Number.parseInt(routeParams.edm_id ?? '');
	const edmDocumentId = routeParams.edm_document_id ?? '';

	const { companies } = useCompanies();
	const auth = useAuthContext();

	const { data } = useDocumentRedirect(edmId, edmDocumentId);
	const navigate = useNavigate();
	useEffect(() => {
		if (data && data.companies) {
			if (auth && auth.authContext !== 'employee') {
				// Investor session
				if (companies && companies.length > 0) {
					if (auth.currentCompany && data.companies.some((x) => x.id === auth.currentCompany?.id)) {
						// Current company already matches a company on the document — nothing to do.
					} else {
						// Switch to the first company on the document that the user has access to.
						const existCompany = data.companies.find((x) => companies.map((c) => c.id).includes(x.id));
						if (existCompany) {
							const tempCurrentCompany = companies.find((x) => x.id === existCompany.id);
							tempCurrentCompany && auth.setCurrentCompany(tempCurrentCompany);
						}
					}

					navigate(HAppRoutes.getPath(DocumentRoutes.document.tag, { id: data.id }));
				}
			} else if (auth && auth.authContext === 'employee' && !!auth.authOverrideUserId) {
				// Employee impersonating an investor
				if (companies && companies.length > 0) {
					if (auth.currentCompany && data.companies.some((x) => x.id === auth.currentCompany?.id)) {
						// Current company already matches — nothing to do.
					} else {
						const existCompany = data.companies.find((x) => companies.map((c) => c.id).includes(x.id));
						if (existCompany) {
							const tempCurrentCompany = companies.find((x) => x.id === existCompany.id);
							tempCurrentCompany && auth.setCurrentCompany(tempCurrentCompany);
						}
					}

					navigate(HAppRoutes.getPath(DocumentRoutes.document.tag, { id: data.id }));
				}
			} else if (auth && auth.authContext === 'employee' && !auth.authOverrideUserId) {
				// Employee with no impersonated investor — bounce through the investors list,
				// pre-filtered by the companies linked to the document.
				auth.setRedirectUri(HAppRoutes.getPath(DocumentRoutes.document.tag, { id: data.id }));
				navigate(
					HAppRoutes.getPath(AdminRoutes.investors_list.tag) +
						'?companys=' +
						data.companies.map((x) => x.id).join(','),
				);
			}
		}
	}, [data, companies, navigate, auth]);

	return <>{data === null ? <AppError404 /> : <AppLoaderContent />}</>;
};

export default PDocumentRedirect;
